import {
  SET_SEA_FCL_JSON,
  SET_SEA_LCL_JSON,
  SET_AIR_JSON,
  SET_QUERY_PARAMS,
  SET_URL,
  UPDATE_ERROR,
  SET_PORT_ORIGIN_JSON,
  SET_PORT_DESTINATION_JSON,
  SET_FILTER_BY_CHEAPER,
  SAVE_SEARCH_FORM_PARAM,
  SET_ORIGINAL_RATE_JSON,
  SET_NEW_RATE_REMAINING_TIME,
  SET_NEW_RATES_APPEAR,
  SEARCH_SHOW_NEW_RATE_CONTACT_FORM,
  UPDATE_POSTAL_ZIP_CODE,
  UPDATE_PICKUP_DELIVERY_ERS_LINE,
  RE_SORT_RATE_CARD,
  SET_JWT_TOKEN,
    SET_CLIENT_JWT,
  SET_USER_DETAILS,
    SET_JWT_TOKEN_TIME,
    SET_FACTORY_FOR_USER,
    NEW_FACTOR_FOR_PICKUP,
  FINAL_SEARCH_FORM,
  FILTER_RATES_BY_CARRIER,
  SET_DISCOUNT,
  SET_RATE_GATE,
  SET_COMMODITY_CATEGORY_LIST,
  INSURANCE_AUTH_TOKEN,
  UPDATE_TRANSIT_TIME,
  UPDATE_PORT_TO_PORT_TRANSIT_TIME,
  SET_SELECTED_SCHEDULE,
  SET_SELECTED_CARRIER,
  SET_SELECTED_ETD_SCHEDULE,
  SET_SELECTED_ETA_SCHEDULE,
  SET_SCHEDULE_ID,
  SHOW_BACK_PORTAL,
  BOOKING_CUSTOMER_FORM,
  SET_EXTERNAL_API_ORIGIN_CHARGES,
  SET_PICKUP_CHARGE_ERROR,
  SET_PICKUP_POSTAL_CODE,
  SET_DELIVERY_POSTAL_CODE,
  SET_DELIVERY_CHARGE_ERROR,
  SET_EXTERNAL_API_PICKUP_CHARGES,
  SET_EXTERNAL_API_DELIVERY_CHARGES,
  SET_DELIVERY_ACCESSORIALS,
  SET_PICKUP_ACCESSORIALS,
  SET_EXTERNAL_API_DESTINATION_CHARGES,
  RESET_CHARGES,
  RESTORE_EXTERNAL_LCL_CHARGES,
  RESET_PICKUP_ORIGIN_CHARGES,
  FCL_WEIGHTS_APPLIED_CMA,
  FCL_SCHEDULE_DATA,
  SET_RATE_PROFILE,
  TOGGLE_ROUTE_SUBSCRIPTION,
  SET_ROUTE_SUBSCRIPTIONS,
  RESET_DELIVERY_DESTINATION_CHARGES,
  SET_DELIVERY_DRAYAGE_LOADING,
  SET_DEFAULT_DESTINATION_CHARGES,
  RESET_PICKUP_CHARGES_ONLY,
  RESET_DELIVERY_CHARGES_ONLY,
} from '../actions/types';

import { RATE_GATE_INITIAL } from '../util/rateGate';
import { getResetPortFeesTo, getResetPortFeesFrom } from '../util/getResetPortsData';
import { isEstimatedCharges } from '../util/getOriginDestinationCharges';

/**
 * @module route_reducer
 * @redux
 * @description It the redux reducer for Search page.
 * @category Search Page
 * @subcategory reducer
 */

/**
 * @type {State}
 * @property {Object} seaFCLJSON - sea FCL rate json
 * @property {Object} seaLCLJSON - sea LCL rate json
 * @property {Object} seaFCLJSON - sea AIR rate json
 *
 * @property {Object} originalRateData - original/initial rate json and loading spinner in uuid mode
 * @property {Object} originalRateData.rateJson - original/initial rate json in uuid mode
 * @property {boolean} originalRateData.loading - whether to show searching spinner for uuid requests below sorting radio button and below rate cards
 *
 * @property {Object} queryParams - query params
 * @property {Object} queryParams.from - origin port e.g. `{ city: "Coffs Harbour", id: 3434, country:"Australia"}`
 * @property {Object} queryParams.to - destination port e.g. `{ city: "Nanaimo", id: 3434, country:"Canada"}`
 * @property {string} queryParams.date - date e.g. `20 May, 2021`
 * @property {string} queryParams.type - transport mode e.g. `api-fcl`, `api-lcl`, `api-air`
 *
 * @property {string} url - url (it has relevant params) so that it can be used in browser address field
 * @property {string} errorMessage - in-app error message notify, shown at bottom-right in case of network error, server error, etc.
 * @property {boolean} loading - should show a loading spinner
 *
 *
 * @property {Object} originPortJSON - origin ports json
 * @property {Object} destinationPortJSON - destination ports json
 *
 * @property {boolean} filterByCheaper - should sort rate cards based on price.
 * `true` - cheapest price rate card is shown at the top.
 * `false` - lowest transit time rate card is shown at the top.
 *
 * @property {boolean} showSearchContactForm - whether to show contact form
 * @property {Object} savedFormParams - save api request property form_params on search page, only when system can't find any rates or error happens during request
 * @property {string} newRatesRemainingTime - remaining time of new rates of UUID request e.g. `1 min 12 sec`
 *
 * @property {boolean | null} newRatesAppear - Do new rate cards present in new rates json by uuid. it is used for showing contact form if no rates appear at all.
 * @property {boolean} showNewRateContactForm -  whether to show contact form above result cards on search page
 * @property {Array} zipCodeArr - save all postal zip code post response obj in array
 * @property {boolean} updatePickupDeliveryErsLine - whether pickup delivery ers line component should be re-rendered
 * @property {boolean} reSortRateCard - re-sort rates cards upon clicking search btn
 *
 */

const INITIAL_STATE = {
  seaFCLJSON: null,
  seaLCLJSON: null,
  airJSON: null,
  originalRateData: {
    rateJson: null,
    loading: false,
  },
  queryParams: {
    from: '',
    to: '',
    date: '',
    type: 'api-fcl',
    discount: ''
  },
  url: '',
  errorMessage: '',
  discount: {},
  rateGate: RATE_GATE_INITIAL,
  commodityList: [],
  insuranceToken: '',
  loading: false,
  // rollback these two ports data now from cache reducer
  originPortJSON: {},
  destinationPortJSON: {},
  chargeTypesData: [],
  defaultDestinationCharges: [],
  pickup_postal_code: "",
  delivery_postal_code: "",
  delivery_drayage_loading: false,
  pickup_charge_error:"",
  delivery_charge_error: "",
  selected_carrier: "",
  schedule_etd_range: null,
  schedule_eta_range: null,
  filterByCheaper: true,
  showSearchContactForm: false,
  savedFormParams: {}, //old form POST request data, it's for when system can not find any rates/error happends during post request,
  newRatesRemainingTime: '',
  newRatesAppear: null, //do new rates present in uuid
  showNewRateContactForm: false,
  zipCodeArr: [], //save all zip code post reaponse obj
  updatePickupDeliveryErsLine: false, //it will re-render component upon changing it's value
  reSortRateCard: true, //re-sort rates cards upon clicking search btn
  routeSubscriptions: [], // saved origin/destination pairs user is subscribed to
  JWT_TOKEN:{},
  USER_DETAILS:{},
  CLIENT_TOKEN:{},
  User_factor_and_shipper_Details:{},
  final_search_form:{},
  rateProfile:{},
  spotOnToken:"",
  hasSpotOnRate:false,
  fclWeightsAppliedCMASpot: false,
  fclScheduleData: {},
  booking_customer_form:{
    customer_type: "Importer",
    email: "",
    customer_first_name: "",
    customer_last_name: "",
    phone: "",
    company_name: "",
    street: "",
    address: "",
    city: "",
    state: "",
    postal: "",
    country: "",
  }
};

const RESET_STATE = {
  pickup_section: [
    {
      name: "Truck",
      currency: "USD",
      description: "Pickup",
      lcl_min_rate: null,
      multiply: true,
      id: "0",
      fetch_zip_code: true,
    },

    {
      name: "Variable Rate",
      rate: "440.00",
      currency: "USD",
      description:
        "Prime Freight will advise of the cartage costs before proceeding with the shipment",
      lcl_min_rate: null,
      multiply: true,
      show_variable_rate: true,
      id: "2",
    },
  ],

  // port of origin
  port_fees_from: [
    [
      "Variable Charge",
      "Variable Charge: Prime Freight will advise of the final origin charges after booking",
      "",
      false,
      "",
    ],
  ],

  // discharge
  port_fees_to: [
    [
      "LLEO",
      "Legal Liability, Errors and Omissions Insurance",
      "5",
      false,
      "5",
      284,
    ],
    ["HBL", "HBL Fee", "25", false, "25", 431],
    ["ACI", "ACI", "30", false, "30.00", 543],
  ],

  delivery_section:[
    {
      name: "To Door Delivery",
      currency: "USD",
      description: "",
      lcl_min_rate: null,
      multiply: true,
      id: "0",
      fetch_zip_code: true,
    },

    {
      name: "Variable Rate",
      rate: "440.00",
      currency: "USD",
      description:
        "Prime Freight will advise of the cartage costs before proceeding with the shipment",
      lcl_min_rate: null,
      multiply: true,
      show_variable_rate: true,
      id: "2",
    },
  ]
  }
/**
 * @memberof module:route_reducer
 * @description It's the route reducer.
 * @type {Redux.Reducer}
 *
 * @param {Redux.Store} state - The current redux state of the route reducer
 * @param {Redux.Action} action - Redux form action
 *
 * @returns {Redux.Store} The updated redux state
 *
 */
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_SEA_FCL_JSON:
      return {
        ...state,
        seaFCLJSON: action.payload,
        seaLCLJSON: {},
        airJSON: {},
        // filterByCheaper: true,
      };
    case UPDATE_TRANSIT_TIME: {
      const { id, transitTime, type } = action.payload;
      if (type !== 'api-fcl') {
        // If the type is not 'api-fcl', do not update transitTime
        return state;
      }

      // Only update seaFCLJSON when type is 'api-fcl'
      return {
        ...state,
        seaFCLJSON: {
          ...state.seaFCLJSON,
          rates: {
            ...state.seaFCLJSON.rates,
            fcl: state?.seaFCLJSON?.rates?.fcl?.map(rate =>
              rate.id === id ? { ...rate, transitTime } : rate
            ),
          },
        },
      };
    }

    case UPDATE_PORT_TO_PORT_TRANSIT_TIME: {
      const { id, portTransitTime, type } = action.payload;
      if (type !== 'api-fcl') {
        // If the type is not 'api-fcl', do not update portTransitTime
        return state;
      }

      // Only update seaFCLJSON when type is 'api-fcl'
      return {
        ...state,
        seaFCLJSON: {
          ...state.seaFCLJSON,
          rates: {
            ...state.seaFCLJSON.rates,
            fcl: state?.seaFCLJSON?.rates?.fcl?.map(rate =>
              rate.id === id ? { ...rate, portTransitTime } : rate
            ),
          },
        },
      };
    }

    case SET_SELECTED_SCHEDULE: {
      const { id, schedule, type } = action.payload;
      if (type !== 'api-fcl') {
        // If the type is not 'api-fcl', do not update transitTime
        return state;
      }

      // Only update seaFCLJSON when type is 'api-fcl'
      return {
        ...state,
        seaFCLJSON: {
          ...state.seaFCLJSON,
          rates: {
            ...state.seaFCLJSON.rates,
            fcl: state.seaFCLJSON.rates.fcl.map(rate => {
            if (rate.id === id) {
              return {
                ...rate,
                selectedSchedule: schedule
              };
            }
            return rate;
          }),
          },
        },
      };
    }
    case SET_SELECTED_CARRIER:
    return {
      ...state,
      selected_carrier:action.payload
    }

    case SET_SELECTED_ETD_SCHEDULE:
      return {
        ...state,
        schedule_etd_range:action.payload
      }
      
    case SET_SELECTED_ETA_SCHEDULE:
      return {
        ...state,
        schedule_eta_range:action.payload
      }

    case SET_SCHEDULE_ID: {
      const { id, schedule, local_schedule_key, type } = action.payload;
      // console.log(" === action.payload ===",action.payload)
      if (type !== 'api-fcl') {
        // If the type is not 'api-fcl', do not update transitTime
        return state;
      }
    
      // Only update seaFCLJSON when type is 'api-fcl'
      return {
        ...state,
        seaFCLJSON: {
          ...state.seaFCLJSON,
          rates: {
            ...state?.seaFCLJSON?.rates,
            fcl: state?.seaFCLJSON?.rates?.fcl?.map(rate => {
              if (rate?.charge_type_id === id) {
                // console.log("Rate id matches action id:", rate.id, id,
                //   "\nlocal_schedule_key: ",local_schedule_key, rate?.local_schedule_key
                // );
                // If schedules is not an array, we directly check for the local_schedule_key in schedules object
                if (rate.schedules && rate.schedules.local_schedule_key === local_schedule_key) {
                  return {
                      ...rate,
                      schedules: schedule
                  };
                }
              }
              //console.log(" === === updated rate === ===",rate)
              return rate; // Return unchanged rate if no match
            }),
          },
        },
      };
    }

    case SET_EXTERNAL_API_PICKUP_CHARGES: {
      const { id, charges, type } = action.payload;
      if (type === 'api-fcl') {
        const applyToAllMatching = action.payload.applyToAllMatching !== false;
        const targetRate = state.seaFCLJSON.rates.fcl.find((rate) => rate.id === id);
        if (!targetRate) return state;
        const targetOriginType = targetRate.ers_checked ? 'rail' : 'marine';
        // Empty-charges path: clears zipCode and rate on every fetch_zip_code option for all
        // matching-origin-type cards. Mirrors the analogous empty-charges branch in
        // SET_EXTERNAL_API_DELIVERY_CHARGES so stale zipCode values don't linger on the
        // pickup option while the rate has already been wiped (e.g. by the pre-clear dispatch
        // in callFclDrayage before the API response arrives).
        if (!charges || charges.length === 0) {
          return {
            ...state,
            seaFCLJSON: {
              ...state.seaFCLJSON,
              rates: {
                ...state.seaFCLJSON.rates,
                fcl: state.seaFCLJSON.rates.fcl.map((rate) => {
                  const originType = rate.ers_checked ? 'rail' : 'marine';
                  if (applyToAllMatching && originType !== targetOriginType) return rate;
                  if (!applyToAllMatching && rate.id !== id) return rate;
                  const clearedPickupSection = Array.isArray(rate.pickup_section)
                    ? rate.pickup_section.map(option =>
                        option?.fetch_zip_code ? { ...option, zipCode: '', rate: [] } : option
                      )
                    : rate.pickup_section;
                  return { ...rate, pickup_section: clearedPickupSection, show_variable_rate: false };
                }),
              },
            },
          };
        }
        return {
          ...state,
          seaFCLJSON: {
            ...state.seaFCLJSON,
            rates: {
              ...state.seaFCLJSON.rates,
              fcl: state.seaFCLJSON.rates.fcl.map((rate) => {
                const originType = rate.ers_checked ? 'rail' : 'marine';
                if (!applyToAllMatching && rate.id !== id) {
                  const clearedPickupSection = Array.isArray(rate.pickup_section)
                    ? rate.pickup_section.map(opt =>
                        opt?.fetch_zip_code ? { ...opt, rate: [], zipCode: '' } : opt
                      )
                    : rate.pickup_section;
                  return { ...rate, pickup_section: clearedPickupSection, show_variable_rate: false };
                }
                if (applyToAllMatching && originType !== targetOriginType) {
                  return rate;
                }
                const updatedPickupSection = Array.isArray(rate.pickup_section) && rate.pickup_section.length > 0
                  ? [
                      { ...rate.pickup_section[0], rate: charges },
                      ...rate.pickup_section.slice(1),
                    ]
                  : [{ rate: charges }];
                return { ...rate, pickup_section: updatedPickupSection, show_variable_rate: false };
              }),
            },
          },
        };
      }
      if (type === 'api-lcl') {
        return {
          ...state,
          seaLCLJSON: {
            ...state.seaLCLJSON,
            rates: {
              ...state.seaLCLJSON.rates,
              lcl: state.seaLCLJSON.rates.lcl.map(rate => {
                if (rate.id !== id) return rate;
                if (rate.id === id) {
                  // If pickup_section exists, update the first element
                  const updatedPickupSection = rate.pickup_section && rate.pickup_section.length > 0
                    ? [
                        {
                          ...rate.pickup_section[0],
                          rate: charges, // Set the rate in the first element
                          // Preserve or restore zipCode so showDeliveryZipOptionForWebUser renders correctly
                          zipCode: rate.pickup_section[0].zipCode || state.pickup_postal_code || undefined,
                        },
                        ...rate.pickup_section.slice(1) // Keep the rest of the elements intact
                      ]
                    : [{ rate: charges }]; // If pickup_section doesn't exist, create a new one
                  return {
                    ...rate,
                    pickup_section: updatedPickupSection,
                    pickup_section_api: updatedPickupSection, // backup for weight-threshold restore
                    show_variable_rate: false, // once postal is provided, treat as non-variable
                  };
                }
                return rate;
              }),
            },
          },
        };
      }
      return state;
    }

     case SET_EXTERNAL_API_DELIVERY_CHARGES: {
      const { id, charges, type } = action.payload;
      // console.log("------------------- action.payload: ",action.payload, state?.seaLCLJSON)
      if (type === 'api-lcl') {
        return {
          ...state,
          seaLCLJSON: {
            ...state.seaLCLJSON,
            rates: {
              ...state.seaLCLJSON.rates,
              lcl: state.seaLCLJSON.rates.lcl.map(rate => {
                const updatedDeliverySection =
                  rate.delivery_section && rate.delivery_section.length > 0
                    ? (() => {
                        const hasZipOption = rate.delivery_section.some(
                          (opt) => opt?.fetch_zip_code
                        );
                        if (hasZipOption) {
                          return rate.delivery_section.map((opt) =>
                            opt?.fetch_zip_code
                              ? {
                                  ...opt,
                                  rate: charges,
                                  // Preserve or restore zipCode so showDeliveryZipOptionForWebUser renders correctly
                                  zipCode: opt.zipCode || state.delivery_postal_code || undefined,
                                }
                              : opt
                          );
                        }
                        return [
                          {
                            ...rate.delivery_section[0],
                            rate: charges,
                            zipCode: rate.delivery_section[0].zipCode || state.delivery_postal_code || undefined,
                          },
                          ...rate.delivery_section.slice(1)
                        ];
                      })()
                    : [{ rate: charges }];
                return {
                  ...rate,
                  delivery_section: updatedDeliverySection,
                  delivery_section_api: updatedDeliverySection, // backup for weight-threshold restore
                  show_variable_rate: false,
                };
              }),
            },
          },
        };
      }
      if (type === 'api-fcl') {
        // console.log("---set charges for fcl-------", charges)
        const applyToAllMatching = action.payload.applyToAllMatching !== false;
        return {
          ...state,
          seaFCLJSON: {
            ...state.seaFCLJSON,
            rates: {
              ...state.seaFCLJSON.rates,
              fcl: (() => {
                const targetRate = state.seaFCLJSON.rates.fcl.find(
                  (rate) => rate.id === id
                );
                if (!targetRate) {
                  return state.seaFCLJSON.rates.fcl;
                }
                const targetOriginType = targetRate.ers_checked ? 'rail' : 'marine';
                if (!charges || charges.length === 0) {
                  return state.seaFCLJSON.rates.fcl.map((rate) => {
                    const originType = rate.ers_checked ? 'rail' : 'marine';
                    if (applyToAllMatching && originType !== targetOriginType) return rate;
                    if (!applyToAllMatching && rate.id !== id) return rate;
                    const clearedDeliverySection = Array.isArray(rate.delivery_section)
                      ? rate.delivery_section.map(option =>
                          option?.fetch_zip_code ? { ...option, zipCode: '', rate: [] } : option
                        )
                      : rate.delivery_section;
                    return {
                      ...rate,
                      calculated_delivery_charges: [],
                      delivery_section: clearedDeliverySection,
                      show_variable_rate: false,
                    };
                  });
                }
                const charge = charges[0];
                const name = charge[0];
                const description = charge[1];
                const price = charge[2];
                const newDeliveryCharge = [];
                newDeliveryCharge[0] = [name, description, price];
                return state.seaFCLJSON.rates.fcl.map((rate) => {
                  const originType = rate.ers_checked ? 'rail' : 'marine';
                  if (!applyToAllMatching && rate.id !== id) {
                    const clearedDeliverySection = Array.isArray(rate.delivery_section)
                      ? rate.delivery_section.map(option =>
                          option?.fetch_zip_code
                            ? {
                                ...option,
                                zipCode: '',
                                rate: Array.isArray(option.rate)
                                  ? option.rate.map((rateItem) =>
                                      Array.isArray(rateItem)
                                        ? [
                                            rateItem[0],
                                            rateItem[1],
                                            0,
                                            rateItem[3],
                                            0,
                                            rateItem[5],
                                          ]
                                        : rateItem
                                    )
                                  : option.rate,
                              }
                            : option
                        )
                      : rate.delivery_section;
                    return {
                      ...rate,
                      calculated_delivery_charges: [],
                      delivery_section: clearedDeliverySection,
                      show_variable_rate: false,
                    };
                  }
                  if (applyToAllMatching && originType !== targetOriginType) {
                    return rate;
                  }
                  return {
                    ...rate,
                    calculated_delivery_charges: newDeliveryCharge,
                    show_variable_rate: false,
                  };
                });
              })(),
            },
          },
        };
      }
      return state;
    }

    case SET_DELIVERY_ACCESSORIALS: {
      const { id, accessorials, type, applyToAllMatching = true } = action.payload;
      if (type !== 'api-fcl') return state;
      const shouldApplyToAll = applyToAllMatching;
      return {
        ...state,
        seaFCLJSON: {
          ...state.seaFCLJSON,
          rates: {
            ...state.seaFCLJSON.rates,
            fcl: (() => {
              const targetRate = state.seaFCLJSON.rates.fcl.find((rate) => rate.id === id);
              if (!targetRate) return state.seaFCLJSON.rates.fcl;
              const targetOriginType = targetRate.ers_checked ? 'rail' : 'marine';
              return state.seaFCLJSON.rates.fcl.map((rate) => {
                const originType = rate.ers_checked ? 'rail' : 'marine';
                if (!shouldApplyToAll && rate.id !== id) {
                  return { ...rate, delivery_accessorials: [] };
                }
                if (shouldApplyToAll && originType !== targetOriginType) {
                  return rate;
                }
                return { ...rate, delivery_accessorials: accessorials };
              });
            })(),
          },
        },
      };
    }

    case SET_PICKUP_ACCESSORIALS: {
      const { id, accessorials, type, applyToAllMatching = true } = action.payload;
      if (type !== 'api-fcl') return state;
      const shouldApplyToAll = applyToAllMatching;
      return {
        ...state,
        seaFCLJSON: {
          ...state.seaFCLJSON,
          rates: {
            ...state.seaFCLJSON.rates,
            fcl: (() => {
              const targetRate = state.seaFCLJSON.rates.fcl.find((rate) => rate.id === id);
              if (!targetRate) return state.seaFCLJSON.rates.fcl;
              const targetOriginType = targetRate.ers_checked ? 'rail' : 'marine';
              return state.seaFCLJSON.rates.fcl.map((rate) => {
                const originType = rate.ers_checked ? 'rail' : 'marine';
                if (!shouldApplyToAll && rate.id !== id) {
                  return { ...rate, pickup_accessorials: [] };
                }
                if (shouldApplyToAll && originType !== targetOriginType) {
                  return rate;
                }
                return { ...rate, pickup_accessorials: accessorials };
              });
            })(),
          },
        },
      };
    }

    case RESET_CHARGES: {
      const type = state.queryParams.type
        if (type !== 'api-lcl') {
          return state;
        }

        if (!Array.isArray(state.seaLCLJSON?.rates?.lcl)) {
          console.warn("No LCL rates found, skipping RESET_CHARGES");
          return state;
        }

        const clearApiOnly = action.payload?.clearApiCharges === true;

        return{
          ...state,
          seaLCLJSON: {
            ...state.seaLCLJSON,
            rates: {
              ...state.seaLCLJSON.rates,
              lcl: state.seaLCLJSON.rates.lcl.map(rate => {
                if (clearApiOnly) {
                  // Weight-exceeded path: drop API-fetched charges, keep static defaults
                  return {
                    ...rate,
                    pickup_section: RESET_STATE.pickup_section,
                    delivery_section: RESET_STATE.delivery_section,
                    port_fees_from: rate.port_fees_from_default || [],
                    port_fees_to: rate.port_fees_to_default || [],
                    pickup_charge_error: "",
                    delivery_charge_error: "",
                  };
                }
                // Role-change / full reset path: rebuild from origin/destination charges
                const rateForReset = { ...rate, destinationCharges: [], originCharges: [] };
                return {
                  ...rate,
                  pickup_section: RESET_STATE.pickup_section,
                  delivery_section: RESET_STATE.delivery_section,
                  port_fees_from: getResetPortFeesFrom(state, rateForReset),
                  port_fees_to: getResetPortFeesTo(state, rateForReset),
                  pickup_charge_error: "",
                  delivery_charge_error: "",
                };
              }),
            },
          },
        }
    }

    case RESTORE_EXTERNAL_LCL_CHARGES: {
      const rType = state.queryParams.type;
      if (rType !== 'api-lcl') return state;
      if (!Array.isArray(state.seaLCLJSON?.rates?.lcl)) return state;

      return {
        ...state,
        seaLCLJSON: {
          ...state.seaLCLJSON,
          rates: {
            ...state.seaLCLJSON.rates,
            lcl: state.seaLCLJSON.rates.lcl.map(rate => ({
              ...rate,
              // Restore origin charges from the API backup only — do not merge with
              // port_fees_from_default (the Variable Charge placeholder) so it never
              // appears alongside actual selling-rate or postal charges.
              port_fees_from: rate.port_fees_from_api || [],
              // Restore destination charges from stored default + API backup
              port_fees_to: [
                ...(rate.port_fees_to_default || []),
                ...(rate.port_fees_to_api || []),
              ],
              // Restore pickup/delivery from their backups (set when ECU charges were fetched)
              pickup_section: rate.pickup_section_api || RESET_STATE.pickup_section,
              delivery_section: rate.delivery_section_api || RESET_STATE.delivery_section,
              pickup_charge_error: '',
              delivery_charge_error: '',
            })),
          },
        },
      };
    }

    case SET_EXTERNAL_API_ORIGIN_CHARGES: {
      const { id, charges, type } = action.payload;
      if (type !== 'api-lcl') {
        // If the type is not 'api-fcl', do not update transitTime
        return state;
      }
      // console.log("---origin charges -------",charges)
      return {
        ...state,
        seaLCLJSON: {
          ...state.seaLCLJSON,
          rates: {
            ...state.seaLCLJSON.rates,
            lcl: state.seaLCLJSON.rates.lcl.map(rate => {
              if (rate.id !== id) return rate;
            // if ((uuid ? (rate.uuid === uuid && rate.id === id) : rate.id === id)) {
              if ((rate.id === id)) {
              return {
                ...rate,
                port_fees_from_api: charges || [],
                // Replace rather than merge: external postal charges stand alone; the
                // Variable Charge placeholder in port_fees_from_default is only shown
                // when clearing (weight > 3000), never alongside actual charges.
                port_fees_from: charges || [],
                // Live postal charges are firm → clear the origin estimate flag.
                origin_charges_estimated: isEstimatedCharges(charges || []),
              };
            }
            return rate;

          }),
          },
        },
      };
    }

    case SET_EXTERNAL_API_DESTINATION_CHARGES: {
      const { id, charges, type } = action.payload;
      if (type !== 'api-lcl') {
        // If the type is not 'api-fcl', do not update transitTime
        return state;
      }
      // Only update seaLCLJSON when type is 'api-fcl'
      return {
        ...state,
        seaLCLJSON: {
          ...state.seaLCLJSON,
          rates: {
            ...state.seaLCLJSON.rates,
            lcl: state.seaLCLJSON.rates.lcl.map(rate => {
              if (rate.id !== id) return rate;
              // if ((uuid ? (rate.uuid === uuid && rate.id === id) : rate.id === id)) {
              if ((rate.id === id)) {
              return {
                ...rate,
                port_fees_to_api: charges || [],
                port_fees_to: [...(rate.port_fees_to_default || []), ...(charges || [])],
                // Live ECU/postal destination charges are firm → recompute the estimate flag
                // from the merged set (defaults are never estimates).
                destination_charges_estimated: isEstimatedCharges([
                  ...(rate.port_fees_to_default || []),
                  ...(charges || []),
                ]),
              };
            }
            // console.log("rate after destination charges: ",rate)
            return rate;
          }),
          },
        },
      };
    }

    case SET_PICKUP_POSTAL_CODE: {
      const nextPostal = action.payload;
      if (
        nextPostal &&
        state.seaFCLJSON &&
        state.seaFCLJSON.rates &&
        Array.isArray(state.seaFCLJSON.rates.fcl)
      ) {
        return {
          ...state,
          pickup_postal_code: nextPostal,
          seaFCLJSON: {
            ...state.seaFCLJSON,
            rates: {
              ...state.seaFCLJSON.rates,
              fcl: state.seaFCLJSON.rates.fcl.map(rate => {
                const updatedPickupSection = Array.isArray(rate.pickup_section)
                  ? rate.pickup_section.map(option =>
                      option?.fetch_zip_code
                        ? { ...option, zipCode: nextPostal }
                        : option
                    )
                  : rate.pickup_section;
                return {
                  ...rate,
                  pickup_section: updatedPickupSection,
                };
              }),
            },
          },
        };
      }
      return {
        ...state,
        pickup_postal_code: nextPostal,
      };
    }

    case SET_DELIVERY_POSTAL_CODE: {
      const nextPostal = action.payload;
      if (nextPostal) {
        if (
          state.seaFCLJSON &&
          state.seaFCLJSON.rates &&
          Array.isArray(state.seaFCLJSON.rates.fcl)
        ) {
          return {
            ...state,
            delivery_postal_code: nextPostal,
            seaFCLJSON: {
              ...state.seaFCLJSON,
              rates: {
                ...state.seaFCLJSON.rates,
                fcl: state.seaFCLJSON.rates.fcl.map(rate => {
                  const updatedDeliverySection = Array.isArray(rate.delivery_section)
                    ? rate.delivery_section.map(option =>
                        option?.fetch_zip_code
                          ? { ...option, zipCode: nextPostal }
                          : option
                      )
                    : rate.delivery_section;
                  return {
                    ...rate,
                    delivery_section: updatedDeliverySection,
                  };
                }),
              },
            },
          };
        }
        return {
          ...state,
          delivery_postal_code: nextPostal,
        };
      }
      if (
        !state.seaFCLJSON ||
        !state.seaFCLJSON.rates ||
        !Array.isArray(state.seaFCLJSON.rates.fcl)
      ) {
        return {
          ...state,
          delivery_postal_code: "",
        };
      }
      return {
        ...state,
        delivery_postal_code: "",
        seaFCLJSON: {
          ...state.seaFCLJSON,
          rates: {
            ...state.seaFCLJSON.rates,
            fcl: state.seaFCLJSON.rates.fcl.map(rate => {
              const updatedDeliverySection = Array.isArray(rate.delivery_section)
                ? rate.delivery_section.map(option =>
                    option?.fetch_zip_code
                      ? {
                          ...option,
                          zipCode: '',
                          rate: Array.isArray(option.rate)
                            ? option.rate.map((rateItem) =>
                                Array.isArray(rateItem)
                                  ? [
                                      rateItem[0],
                                      rateItem[1],
                                      0,
                                      rateItem[3],
                                      0,
                                      rateItem[5],
                                    ]
                                  : rateItem
                              )
                            : option.rate,
                        }
                      : option
                  )
                : rate.delivery_section;
              return {
                ...rate,
                calculated_delivery_charges: [],
                delivery_section: updatedDeliverySection,
                delivery_charge_error: "",
              };
            }),
          },
        },
      };
    }

    case SET_PICKUP_CHARGE_ERROR: {
      const { id, errMsg, type } = action.payload;
      
      if (type === 'api-lcl') {
        return {
          ...state,
          seaLCLJSON: {
            ...state.seaLCLJSON,
            rates: {
              ...state.seaLCLJSON.rates,
              lcl: state.seaLCLJSON.rates.lcl.map(rate => {
                if (rate.id === id) {
                  return {
                    ...rate,
                    pickup_charge_error: errMsg
                  };
                }
                return rate;
              }),
            },
          },
        };
      } else if (type === 'api-fcl') {
        return {
          ...state,
          seaFCLJSON: {
            ...state.seaFCLJSON,
            rates: {
              ...state.seaFCLJSON.rates,
              fcl: state.seaFCLJSON.rates.fcl.map(rate => {
                if (rate.id === id) {
                  return {
                    ...rate,
                    pickup_charge_error: errMsg
                  };
                }
                return rate;
              }),
            },
          },
        };
      }
      
      return state;
    }

    case SET_DELIVERY_CHARGE_ERROR: {
      const { id, errMsg, type } = action.payload;
      if (type === 'api-lcl') {
        return {
          ...state,
          seaLCLJSON: {
            ...state.seaLCLJSON,
            rates: {
              ...state.seaLCLJSON.rates,
              lcl: state.seaLCLJSON.rates.lcl.map(rate => {
                if (rate.id === id) {
                  return {
                    ...rate,
                    delivery_charge_error: errMsg
                  };
                }
                return rate;
              }),
            },
          },
        };
      }
      if (type === 'api-fcl') {
        return {
          ...state,
          seaFCLJSON: {
            ...state.seaFCLJSON,
            rates: {
              ...state.seaFCLJSON.rates,
              fcl: state.seaFCLJSON.rates.fcl.map(rate => {
                if (rate.id === id) {
                  return {
                    ...rate,
                    delivery_charge_error: errMsg
                  };
                }
                return rate;
              }),
            },
          },
        };
      }
      return state;
    }

    case RESET_PICKUP_ORIGIN_CHARGES: {
      const { id, type } = action.payload; // eslint-disable-line no-unused-vars
      if (type === 'api-fcl') {
        // FCL intentionally resets all rates, not just the one matching `id`.
        // This mirrors the applyToAllMatching pattern used in SET_EXTERNAL_API_PICKUP_CHARGES:
        // when the shipper location changes, every FCL rate's dray rate and accessorials
        // must be cleared so stale data from the previous location is not shown.
        return {
          ...state,
          seaFCLJSON: {
            ...state.seaFCLJSON,
            rates: {
              ...state.seaFCLJSON.rates,
              fcl: state.seaFCLJSON.rates.fcl.map(rate => {
                const updatedPickupSection = Array.isArray(rate.pickup_section)
                  ? rate.pickup_section.map(option =>
                      option?.fetch_zip_code
                        ? { ...option, zipCode: '', rate: [] }
                        : option
                    )
                  : rate.pickup_section;
                return {
                  ...rate,
                  pickup_section: updatedPickupSection,
                  pickup_accessorials: [],
                };
              }),
            },
          },
        };
      }
      if (type === 'api-lcl') {
        return {
          ...state,
          seaLCLJSON: {
            ...state.seaLCLJSON,
            rates: {
              ...state.seaLCLJSON.rates,
              lcl: state.seaLCLJSON.rates.lcl.map(rate => {
                if (rate.id !== id) return rate;
                return {
                  ...rate,
                  pickup_section: RESET_STATE.pickup_section,
                  port_fees_from: RESET_STATE.port_fees_from,
                  // pickup_charge_error: "",
                };
              }),
            },
          },
        };
      }
      return state;
    }

    case RESET_PICKUP_CHARGES_ONLY: {
      const { id, type } = action.payload;
      if (type === 'api-fcl') {
        // Intentionally clears ALL FCL rates regardless of origin type (rail vs marine).
        // Because both origin types share the same pickup postal code/location, a location
        // change must wipe every card so no stale charges remain while new fetches are in-flight.
        // SET operations (SET_EXTERNAL_API_PICKUP_CHARGES / SET_PICKUP_ACCESSORIALS) correctly
        // scope updates to the matching origin type, keeping rail and marine cards in sync.
        return {
          ...state,
          seaFCLJSON: {
            ...state.seaFCLJSON,
            rates: {
              ...state.seaFCLJSON.rates,
              fcl: state.seaFCLJSON.rates.fcl.map(rate => {
                const updatedPickupSection = Array.isArray(rate.pickup_section)
                  ? rate.pickup_section.map(option =>
                      option?.fetch_zip_code
                        ? { ...option, zipCode: '', rate: [] }
                        : option
                    )
                  : rate.pickup_section;
                return {
                  ...rate,
                  pickup_section: updatedPickupSection,
                  pickup_accessorials: [],
                };
              }),
            },
          },
        };
      }
      if (type === 'api-lcl') {
        return {
          ...state,
          seaLCLJSON: {
            ...state.seaLCLJSON,
            rates: {
              ...state.seaLCLJSON.rates,
              lcl: state.seaLCLJSON.rates.lcl.map(rate => {
                if (rate.id !== id) return rate;
                return {
                  ...rate,
                  pickup_section: RESET_STATE.pickup_section,
                };
              }),
            },
          },
        };
      }
      return state;
    }

    case RESET_DELIVERY_CHARGES_ONLY: {
      const { id, type } = action.payload;
      if (type === 'api-fcl') {
        // Intentionally clears ALL FCL rates regardless of origin type (rail vs marine).
        // Because both origin types share the same delivery postal code/location, a location
        // change must wipe every card so no stale charges remain while new fetches are in-flight.
        // SET operations (SET_EXTERNAL_API_DELIVERY_CHARGES / SET_DELIVERY_ACCESSORIALS) correctly
        // scope updates to the matching origin type, keeping rail and marine cards in sync.
        return {
          ...state,
          seaFCLJSON: {
            ...state.seaFCLJSON,
            rates: {
              ...state.seaFCLJSON.rates,
              fcl: state.seaFCLJSON.rates.fcl.map(rate => {
                const updatedDeliverySection = Array.isArray(rate.delivery_section)
                  ? rate.delivery_section.map(option =>
                      option?.fetch_zip_code
                        ? { ...option, zipCode: '', rate: [] }
                        : option
                    )
                  : rate.delivery_section;
                return {
                  ...rate,
                  calculated_delivery_charges: [],
                  delivery_section: updatedDeliverySection,
                  delivery_accessorials: [],
                };
              }),
            },
          },
        };
      }
      if (type === 'api-lcl') {
        return {
          ...state,
          seaLCLJSON: {
            ...state.seaLCLJSON,
            rates: {
              ...state.seaLCLJSON.rates,
              lcl: state.seaLCLJSON.rates.lcl.map(rate => {
                if (rate.id !== id) return rate;
                return {
                  ...rate,
                  delivery_section: RESET_STATE.delivery_section,
                  delivery_accessorials: [],
                };
              }),
            },
          },
        };
      }
      return state;
    }
    case RESET_DELIVERY_DESTINATION_CHARGES: {
      const { id, type } = action.payload;
      if (type === 'api-lcl') {
        return {
          ...state,
          seaLCLJSON: {
            ...state.seaLCLJSON,
            rates: {
              ...state.seaLCLJSON.rates,
              lcl: state.seaLCLJSON.rates.lcl.map(rate => {
                if (rate.id !== id) return rate;

                return {
                  ...rate,
                  delivery_section: RESET_STATE.delivery_section,
                  port_fees_to: RESET_STATE.port_fees_to,
                  //delivery_charge_error: "",
                };
              }),
            },
          },
        };
      }
      if (type === 'api-fcl') {
        return {
          ...state,
          seaFCLJSON: {
            ...state.seaFCLJSON,
            rates: {
              ...state.seaFCLJSON.rates,
              fcl: state.seaFCLJSON.rates.fcl.map(rate => {
                const updatedDeliverySection = Array.isArray(rate.delivery_section)
                  ? rate.delivery_section.map(option =>
                      option?.fetch_zip_code
                        ? { ...option, zipCode: '', rate: [] }
                        : option
                    )
                  : rate.delivery_section;
                return {
                  ...rate,
                  calculated_delivery_charges: [],
                  delivery_section: updatedDeliverySection,
                  delivery_accessorials: [],
                  //delivery_charge_error: "",
                };
              }),
            },
          },
        };
      }
      return state;
    }
    case SET_DELIVERY_DRAYAGE_LOADING: {
      return {
        ...state,
        delivery_drayage_loading: Boolean(action.payload),
      };
    }
    case SET_DEFAULT_DESTINATION_CHARGES:
      return {
        ...state,
        defaultDestinationCharges: action.payload,
    }
    case FINAL_SEARCH_FORM:
      return {
        ...state,
        final_search_form:action.payload
      }
    case BOOKING_CUSTOMER_FORM:
      return {
        ...state,
        booking_customer_form:action.payload
    }
    case FILTER_RATES_BY_CARRIER:
      return {
        ...state,
        seaFCLJSON: { ...state.seaFCLJSON, ...action.payload },
      };
    case TOGGLE_ROUTE_SUBSCRIPTION: {
      const { fromId, toId, source = 'global', rateId, carrierId, dischargePortId, routeSubscriptionId, isFcl, isLcl } = action.payload || {};
      if (!fromId || !toId) {
        return state;
      }

      const existingIndex = state.routeSubscriptions.findIndex((item) => {
        const sameId =
          routeSubscriptionId &&
          (item.routeSubscriptionId === routeSubscriptionId ||
            item.id === routeSubscriptionId);

        if (sameId) return true;

        const sameSource = (item.source || 'global') === (source || 'global');

        const sameRoute =
          (item.fromId === fromId || item.originPort === fromId) &&
          (item.toId === toId || item.destinationPort === toId);

        const sameRate = rateId ? item.rateId === rateId : true;
        const sameCarrier = carrierId ? item.carrierId === carrierId : true;
        const sameDischarge = dischargePortId ? item.dischargePortId === dischargePortId : true;

        return sameSource && sameRoute && sameRate && sameCarrier && sameDischarge;
      });

      const updatedSubscriptions =
        existingIndex >= 0
          ? state.routeSubscriptions.map((item, idx) =>
              idx === existingIndex
                ? {
                    originPort: fromId,
                    destinationPort: toId,
                    carrier: carrierId,
                    dischargePort: dischargePortId,
                    id: routeSubscriptionId || item.routeSubscriptionId || item.id,
                    source,
                    isFcl,
                    isLcl,
                  }
                : item
            )
          : [
              ...state.routeSubscriptions,
              {
                originPort: fromId,
                destinationPort: toId,
                carrier: carrierId,
                dischargePort: dischargePortId,
                id: routeSubscriptionId,
                source,
                isFcl,
                isLcl,
              },
            ];
      // console.log("updatedSubscriptions: ",updatedSubscriptions)
      return {
        ...state,
        routeSubscriptions: updatedSubscriptions,
      };
    }
    case SET_ROUTE_SUBSCRIPTIONS:
      return { ...state, routeSubscriptions: action.payload };
    case SET_SEA_LCL_JSON:
      return {
        ...state,
        seaLCLJSON: action.payload,
        seaFCLJSON: {},
        airJSON: {},
        // filterByCheaper: true,
      };
    case SET_AIR_JSON:
      // console.log('*******air json: ', action.payload);
      return {
        ...state,
        airJSON: action.payload,
        seaFCLJSON: {},
        seaLCLJSON: {},
        // filterByCheaper: true,
      };
    case SET_ORIGINAL_RATE_JSON:
      return {
        ...state,
        originalRateData: { ...state.originalRateData, ...action.payload },
      };

    case FCL_WEIGHTS_APPLIED_CMA:
      return { ...state, fclWeightsAppliedCMASpot: action.payload };
    case FCL_SCHEDULE_DATA:
      return { ...state, fclScheduleData: action.payload };
    case SET_RATE_PROFILE:
      return { ...state, rateProfile: action.payload };
    case SET_QUERY_PARAMS:
      return { ...state, queryParams: action.payload };
    case SET_DISCOUNT:
      return { ...state, discount: action.payload };
    case SET_RATE_GATE:
      return { ...state, rateGate: { ...state.rateGate, ...action.payload } };
    case SET_COMMODITY_CATEGORY_LIST:
      return { ...state, commodityList: action.payload };
    case INSURANCE_AUTH_TOKEN:
      return { ...state, insuranceToken: action.payload };
    case SET_URL:
      return { ...state, url: action.payload };
    case UPDATE_ERROR:
      return {
        ...state,
        errorMessage: action.payload.error,
        loading: action.payload.loading,
      };

    case SET_PORT_ORIGIN_JSON:
      return { ...state,
        originPortJSON: action.payload
      };

    case SET_PORT_DESTINATION_JSON:
      return { ...state, destinationPortJSON: action.payload };

    case SET_FILTER_BY_CHEAPER:
      return { ...state, filterByCheaper: action.payload };

    case SAVE_SEARCH_FORM_PARAM:
      return {
        ...state,
        savedFormParams: action.payload.form_params,
        showSearchContactForm: action.payload.show,
      };
    // it is for showing contact form in case no new rates appear by uuid
    case SEARCH_SHOW_NEW_RATE_CONTACT_FORM:
      return {
        ...state,
        showNewRateContactForm: action.payload,
      };
    case SET_NEW_RATE_REMAINING_TIME:
      return {
        ...state,
        newRatesRemainingTime: action.payload,
      };
    case SET_NEW_RATES_APPEAR:
      return {
        ...state,
        newRatesAppear: action.payload,
      };
    case SHOW_BACK_PORTAL:
      return { ...state, showBackBtn: action.payload };
    case UPDATE_POSTAL_ZIP_CODE:
      return {
        ...state,
        zipCodeArr: action.payload || [],
      };
    case UPDATE_PICKUP_DELIVERY_ERS_LINE:
      return {
        ...state,
        updatePickupDeliveryErsLine: state.updatePickupDeliveryErsLine
          ? false
          : true,
      };
    case RE_SORT_RATE_CARD:
      return {
        ...state,
        reSortRateCard: state.reSortRateCard ? false : true,
      };
    case SET_JWT_TOKEN:

      return {
        ...state,
        JWT_TOKEN:action.payload,
      };
    case SET_USER_DETAILS:
      return {
        ...state,
        USER_DETAILS :action.payload,
      }
    case SET_CLIENT_JWT:
      return {
        ...state,
        CLIENT_TOKEN:action.payload,
      }

    case SET_FACTORY_FOR_USER:
      return {
        ...state,
        User_factor_and_shipper_Details:action.payload,
      }
    default:
      return state;
  }
};
